import React, { useState, useMemo } from "react";
import Modalpopup from "../../../../shared/components/Modalpopup";
import DefaultButton from "../../../../shared/components/DefaultButton";
import Modal from "react-bootstrap/Modal";
import { Card, Row, Col, Form, OverlayTrigger, Tooltip } from "react-bootstrap";
import InternalNotes from "./InternalNotes";
import CCRecipients from "./CCRecipients";
import "./Ticketing.css";


const TicketMessages = ({ values, setFieldValue, messages, internal_notes }) => {

  const [showModal, setShowModal] = useState(false);
  const [selectedMessage, setSelectedMessage] = useState(null);
  const [showImageModal, setShowImageModal] = useState(false);
  const [previewImageUrl, setPreviewImageUrl] = useState("");
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [attachments, setAttachments] = useState([]);
  const [previewType, setPreviewType] = useState("");
  const [showAll, setShowAll] = useState(false);
  const [showAllModal, setShowAllModal] = useState(false);
  const emp_no = JSON.parse(localStorage.getItem("emp_no"));
  const [zoom, setZoom] = useState(1);
  
  console.log("Meassages", messages);

  // To show only 3 message 
  const sortedMessages = useMemo(() => {
    return [...messages].sort(   (a, b) => new Date(b.updated_at) - new Date(a.updated_at) );
  }, [messages]);
 
  const displayedMessages = showAll ? sortedMessages : sortedMessages.slice(0, 3);

  // Extract IDs once
  const messageIds = useMemo(() => sortedMessages.map(m => m.id), [sortedMessages]);

  const handleRowClick = (msg) => {
    setSelectedMessage(msg);
    setShowModal(true);
  };

  const handleClose = () => {
    setShowModal(false);
    setSelectedMessage(null);
  };

  const handlePrev = () => {
    const idx = messageIds.indexOf(selectedMessage.id);
    if (idx > 0) {
      setSelectedMessage(sortedMessages[idx - 1]);
    }
  };

  const handleNext = () => {
    const idx = messageIds.indexOf(selectedMessage.id);
    if (idx < messageIds.length - 1) {
      setSelectedMessage(sortedMessages[idx + 1]);
    }
  };

  const currentIndex = selectedMessage ? messageIds.indexOf(selectedMessage.id) : -1;

  // Limit the body to 100 words
  const truncateHTML = (html, maxLength = 100) => {
  const div = document.createElement("div");
  div.innerHTML = html;

  const text = div.textContent || div.innerText || "";

  if (text.length <= maxLength) return text;

  return text.substring(0, maxLength) + "...";
};


  const getPreviewType = (fileName) => {
    const ext = fileName.split(".").pop().toLowerCase();

    if (["jpg","jpeg","png","gif","webp","svg"].includes(ext)) return "image"; 
    if (ext === "pdf") return "pdf";
    if (["mp4","webm","mov","m4v"].includes(ext)) return "video";
    if (["mp3","wav","ogg"].includes(ext)) return "audio";  
    if (["txt","csv"].includes(ext)) return "text";    
    if (["doc","docx","xls","xlsx","ppt","pptx"].includes(ext)) return "office";
    return "unknown"; // Download only
  };

  const getFileIcon = (fileName) => {
    const ext = fileName.split(".").pop().toLowerCase();
    if (["jpg","jpeg","png","gif","webp","svg"].includes(ext))
      return "far fa-image text-primary";
    if (ext === "pdf")
      return "far fa-file-pdf text-danger";
    if (["doc","docx"].includes(ext))
      return "far fa-file-word text-primary";
    if (["xls","xlsx"].includes(ext))
      return "far fa-file-excel text-success";
    if (["mp4","webm","mov","avi","mkv","wmv","mpeg","mpg","flv","ogv","3gp","m4v"].includes(ext))
      return "far fa-file-video text-warning";
    if (["mp3","wav","ogg"].includes(ext))
      return "far fa-file-audio text-info";
    return "far fa-file text-secondary";
  };


  const handleAttachmentClick = (file, msg) => {
    if (!msg) return; // safeguard

    const files = msg.attachments || [];
    const index = files.findIndex((f) => f.id === file.id);

    setSelectedMessage(msg);      
    setAttachments(files);
    setCurrentImageIndex(index);

    const type = getPreviewType(file.file_name);
    setPreviewType(type);
    setPreviewImageUrl(file.signed_url);

    setTimeout(() => setShowImageModal(true), 20);
};

  const forceDownload = (url, fileName) => {
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", fileName);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
  
  const stripHTML = (html) => {
    const div = document.createElement("div");
    div.innerHTML = html;
    return div.textContent || div.innerText || "";
  };


  return (
    <div className={showModal || showImageModal || showAllModal ? "blur-background" : ""}>
      <div className="d-flex justify-content-between align-items-center mb-2">
          <h6 style={{ fontWeight: 600, marginBottom: 0 }}>
            Messages
          </h6>

          {messages.length > 3 && (
            <div className="d-flex align-items-center gap-4">
              {/* Show All / Show Less */}
              <span
                onClick={() => setShowAll((prev) => !prev)}
                style={{
                  cursor: "pointer",
                  fontWeight: 600,
                  color: "#6c757d",
                  display: "flex",
                  alignItems: "center",
                  gap: "6px",
                }}
              >
                <i
                  className={`fa-solid ${
                    showAll ? "fa-chevron-up" : "fa-chevron-down"
                  }`}
                  style={{ fontSize: "12px" }}
                />
                {showAll ? "Show Less" : "Show All"}
              </span>
              {/* Separator */}
              <span style={{ color: "#6c757d" }}>|</span>

              {/* Open All */}
              <span
                onClick={() => setShowAllModal(true)}
                style={{
                  cursor: "pointer",
                  fontWeight: 600,
                  color: "#6c757d",
                  display: "flex",
                  alignItems: "center",
                  gap: "6px",
                }}
              >
                <i className="fa-solid fa-arrow-up-right-from-square" />
                Open All
              </span>
            </div>
          )}
        </div>

      <div className="table-responsive">
        <table className="table table-bordered table-striped">
          <thead>
            <tr className="message-table-header">
              <th style={{ width: "130px" }}>Time</th>
              <th style={{ width: "180px"}}>From</th>
              <th style={{ width: "180px" }}>To</th>
              <th style={{ width: "180px" }} className="cc-column">CC</th>
              <th style={{ width: "40%" }}>Body</th>
            </tr>
          </thead>
          <tbody>
            {displayedMessages.length ? (
              displayedMessages.map((item) => (
                <tr
                  key={item.id}
                  onClick={() => handleRowClick(item)}
                  style={{ cursor: "pointer" }}
                >
                  <td>{item.updated_at}</td>
                  <td>{item.from_employee_name}</td>
                  <td>{item.to_employee_name}</td>
                  <td className="cc-column" onClick={(e) => e.stopPropagation()}>
                    <CCRecipients ccRecipients={item.cc_recipients} />
                  </td>
                  <td>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        gap: "12px",
                      }}
                    >
                      {/* Message body + view icon */}
                      <div
                        style={{
                          maxWidth: "420px",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          display: "flex",
                          alignItems: "center",
                          gap: "8px",
                        }}
                      >
                        <span className="message-preview">
                          {truncateHTML(item.body, 50)}
                        </span>

                        <span
                          style={{ cursor: "pointer", fontWeight: 600 }}
                          onClick={() => {
                            setSelectedMessage(item);
                            setShowModal(true);
                          }}
                        >
                          <i className="fa-solid fa-eye eye-icon" />
                        </span>
                      </div>

                      {/* Attachment badge at END */}
                      {item.attachments?.length > 0 && (
                        <span        
                          className="badge attachment-badge"
                          title={`${item.attachments.length} attachment(s)`}
                          onClick={(e) => {
                            e.stopPropagation();
                            setSelectedMessage(item);
                            setAttachments(item.attachments);
                            setCurrentImageIndex(0);
                            setPreviewType(
                              getPreviewType(item.attachments[0].file_name)
                            );
                            setPreviewImageUrl(item.attachments[0].signed_url);
                            setShowImageModal(true);
                          }}
                        >
                          <i className="fa-solid fa-paperclip" />
                          {item.attachments.length}
                        </span>
                      )}
                    </div>
                  </td>
              
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="5" className="text-center">No messages available</td>
              </tr>
            )}
          </tbody>
        </table>        
      </div>
      {/* INTERNAL NOTES */}
        <div className="mt-4">
          <label style={{ fontWeight: 600 }}>Internal Notes</label>
          <textarea
            className="form-control"
            rows={4}
            placeholder="Write internal notes here..."
            value={values.internal_notes}
            onChange={(e) => setFieldValue("internal_notes", e.target.value)}
          />
        </div>   

        <div className="mt-4">          
          <InternalNotes notes={internal_notes} />
       </div>    

      {/* Model to show single message */}
      <Modalpopup  show={showModal} handleClose={handleClose}  actionTitle="Message Details" size="lg">
        <div style={{ height: '80vh', overflowY: 'auto' }}>
        {selectedMessage && (
          <div>
            {/* Navigation Buttons */}
            <div className="d-flex justify-content-between mb-3">
              <DefaultButton
                buttonClass="default-btn-color"
                buttonTitle={<i className="fas fa-arrow-left"></i>}
                actionBlock={handlePrev}
                disabled={currentIndex === 0}
              />
              <DefaultButton
                buttonClass="default-btn-color"
                buttonTitle={<i className="fas fa-arrow-right"></i>}
                actionBlock={handleNext}
                disabled={currentIndex === messageIds.length - 1}
              />
            </div>

            {/* Aligned fields */}
            <div style={{ marginTop: "6px",background: "#f7f7f7",padding: "15px",borderRadius: "6px"}}>
              <div style={{ display: "grid",gridTemplateColumns: "60px auto", rowGap: "10px",columnGap: "40px",alignItems: "start" }}>
                <div style={{fontWeight: 600 }}>Time:</div>
                <div>{selectedMessage.updated_at}</div>

                <div style={{fontWeight: 600 }}>From:</div>
                <div>{selectedMessage.from_employee_name || "-"}</div>

                <div style={{fontWeight: 600 }}>To:</div>
                <div>{selectedMessage.to_employee_name || "-"}</div>

                <div style={{fontWeight: 600 }}>Body:</div>
                <div className="message-body" dangerouslySetInnerHTML={{ __html: selectedMessage.body }} style={{ whiteSpace: "normal", wordBreak: "break-word" }}/>
                
                <div style={{ fontWeight: 600 }}>Attachments:</div>
                <div className="d-flex flex-wrap gap-4">
                  {selectedMessage.attachments.map((att) => (
                    <div
                      key={att.id}
                      className="d-flex align-items-center"
                      style={{ gap: "8px", minWidth: "200px" }}
                    >
                      <i
                        className={getFileIcon(att.file_name)}
                        style={{ fontSize: "18px" }}
                      ></i>

                      <button
                        type="button"
                        className="btn btn-link p-0 text-start"
                        onClick={() => handleAttachmentClick(att, selectedMessage)}
                        style={{
                          fontSize: "14px",
                          maxWidth: "160px",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                        }}
                      >
                        {att.file_name}
                      </button>
                    </div>
                  ))}

                </div>
              </div>
            </div>

          </div>
        )}
        </div>
      </Modalpopup>

      {/* Model to show the attachments */}
              <Modal show={showImageModal} onHide={() => setShowImageModal(false)} size="lg" centered height={"10vh"}>
                <Modal.Header closeButton className="d-flex align-items-center">
                  <Modal.Title className="m-0">Attachment Preview</Modal.Title>
                  <div className="flex-grow-1"></div>
                  
                  <div className="icon-btn-group">
                    <OverlayTrigger placement="bottom" overlay={<Tooltip>Zoom In</Tooltip>}>
                      <button
                        className="btn btn-sm btn-outline-secondary icon-btn"
                        onClick={() => setZoom((z) => Math.min(z + 0.2, 3))}
                      >
                        <i className="fas fa-plus-circle text-white"></i>
                      </button>
                    </OverlayTrigger>

                    <OverlayTrigger placement="bottom" overlay={<Tooltip>Reset Zoom</Tooltip>}>
                      <button
                        className="btn btn-sm btn-outline-secondary icon-btn"
                        onClick={() => setZoom(1)}
                      >
                        <i className="fas fa-undo-alt text-white"></i>
                      </button>
                    </OverlayTrigger>

                    <OverlayTrigger placement="bottom" overlay={<Tooltip>Zoom Out</Tooltip>}>
                      <button
                        className="btn btn-sm btn-outline-secondary icon-btn"
                        onClick={() => setZoom((z) => Math.max(z - 0.2, 0.5))}
                      >
                        <i className="fas fa-minus-circle text-white"></i>
                      </button>
                    </OverlayTrigger>

                    <OverlayTrigger placement="bottom" overlay={<Tooltip>Download</Tooltip>}>
                      <button
                        className="btn btn-sm btn-outline-secondary icon-btn"
                        onClick={() => {
                          const file = attachments[currentImageIndex];
                          forceDownload(file.signed_url, file.file_name);
                        }}
                      >
                        <i className="fas fa-download text-white"></i>
                      </button>
                    </OverlayTrigger>
                  </div>
                </Modal.Header>

                {/* Navigation buttons */}
                <div className="d-flex justify-content-between align-items-center px-3 mt-2">
                  <DefaultButton
                    buttonClass="default-btn-color"
                    buttonTitle={<i className="fas fa-arrow-left"></i>}
                    actionBlock={() => {
                      const newIndex = currentImageIndex - 1;
                      setCurrentImageIndex(newIndex);
                      const f = attachments[newIndex];
                      setPreviewImageUrl(f.signed_url);
                      setPreviewType(getPreviewType(f.file_name));
                    }}
                    disabled={currentImageIndex === 0}
                  />

                  <div style={{ fontSize: "14px", fontWeight: "bold" }}>
                    {currentImageIndex + 1} / {attachments.length}
                  </div>

                  <DefaultButton
                    buttonClass="default-btn-color"
                    buttonTitle={<i className="fas fa-arrow-right"></i>}
                    actionBlock={() => {
                      const newIndex = currentImageIndex + 1;
                      setCurrentImageIndex(newIndex);
                      const f = attachments[newIndex];
                      setPreviewImageUrl(f.signed_url);
                      setPreviewType(getPreviewType(f.file_name));
                    }}
                    disabled={currentImageIndex === attachments.length - 1}
                  />
                </div>

                <Modal.Body className="text-center" style={{ height: "500px", overflow: "auto" }}>
                  <div
                    style={{
                      transform: `scale(${zoom})`,
                      transformOrigin: zoom > 1 ? "top left" : "center",   // ← CHANGED
                      transition: "transform 0.2s ease",
                      display: "inline-block",
                      width: "100%",
                    }}
                  >
                    {previewType === "image" && (
                      <img
                        src={previewImageUrl}
                        alt="Preview"
                        style={{ maxWidth: "100%", maxHeight: "80vh", borderRadius: "8px" }}
                      />
                    )}
                    {previewType === "pdf" && (
                      <iframe
                        src={previewImageUrl}
                        style={{ width: "100%", height: "80vh", border: "none" }}
                        title="PDF Preview"
                      ></iframe>
                    )}
                    {previewType === "video" && (
                        <video
                          key={previewImageUrl}
                          controls
                          style={{ maxWidth: "100%", maxHeight: "80vh" }}
                        >
                          <source
                            src={previewImageUrl}
                            type={
                              previewImageUrl.endsWith(".mov")
                                ? "video/quicktime"
                                : previewImageUrl.endsWith(".webm")
                                ? "video/webm"
                                : "video/mp4"
                            }
                          />
                          Your browser does not support this video format.
                        </video>
                      )}
                    {previewType === "audio" && (
                      <audio controls style={{ width: "100%" }}>
                        <source src={previewImageUrl} />
                      </audio>
                    )}
                    {previewType === "text" && (
                      <iframe
                        src={previewImageUrl}
                        style={{ width: "100%", height: "80vh", border: "none" }}
                      ></iframe>
                    )}
                    {previewType === "office" && (
                      <iframe
                        src={`https://docs.google.com/viewer?url=${encodeURIComponent(
                          previewImageUrl
                        )}&embedded=true`}
                        style={{ width: "100%", height: "80vh", border: "none" }}
                        title="Office Preview"
                      ></iframe>
                    )}
                    {previewType === "unknown" && (
                      <p className="text-muted">
                        Preview not available for this file. Click download instead.
                      </p>
                    )}
                  </div>
                </Modal.Body>
              </Modal>

            {/*Model to show all messages   */}                
            <Modalpopup  show={showAllModal} handleClose={() => setShowAllModal(false)} actionTitle="All Messages"  size="xl" >
              <div style={{ maxHeight: "70vh", overflowY: "auto", padding: "15px" }}>

                {/* Group messages by date */}
                {Object.entries(
                  sortedMessages.reduce((groups, msg) => {
                    const date = new Date(msg.updated_at).toDateString();
                    if (!groups[date]) groups[date] = [];
                    groups[date].push(msg);
                    return groups;
                  }, {})
                ).map(([dateKey, msgs]) => {
                  // Convert date label
                  const today = new Date().toDateString();
                  const yesterday = new Date(Date.now() - 86400000).toDateString();

                  const formattedDate =
                    dateKey === today
                      ? "Today"
                      : dateKey === yesterday
                      ? "Yesterday"
                      : new Date(dateKey).toLocaleDateString("en-IN", {
                          day: "2-digit",
                          month: "short",
                          year: "numeric",
                        });

                  return (
                    <div key={dateKey} style={{ marginBottom: "25px" }}>
                      
                      {/* ---- DATE SEPARATOR ---- */}
                      <div
                        style={{
                          textAlign: "center",
                          margin: "20px 0",
                          fontWeight: 600,
                          color: "#666",
                        }}
                      >
                        {formattedDate}
                      </div>

                      {/* ---- MESSAGES UNDER THIS DATE ---- */}
                      {msgs.map((msg) => {
                        const isMe = msg.from_employee_name?.toLowerCase() === emp_no ;
                        const initials = (msg.from_employee_name || "?")
                          .split(" ")
                          .map((n) => n[0])
                          .join("")
                          .substring(0, 2)
                          .toUpperCase();

                        return (
                          <div
                            key={msg.id}
                            style={{
                              display: "flex",
                              justifyContent: isMe ? "flex-end" : "flex-start",
                              marginBottom: "18px",
                              gap: "10px",
                              alignItems: "flex-start",
                            }}
                          >
                            {/* Avatar left for incoming, right for outgoing */}
                            {!isMe && (
                              <div
                                style={{
                                  width: "42px",
                                  height: "42px",
                                  borderRadius: "50%",
                                  background: "#007bff",
                                  color: "#fff",
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                  fontWeight: 700,
                                  fontSize: "14px",
                                  flexShrink: 0,
                                }}
                              >
                                {initials}
                              </div>
                            )}

                            {/* Bubble */}
                            <div className={`message-bubble ${isMe ? "message-bubble--me" : "message-bubble--other"}`}  >
                              {/* Time */}
                              <div
                                style={{
                                  fontSize: "12px",
                                  color: "#555",
                                  marginBottom: "4px",
                                }}
                              >
                                <i className="far fa-clock me-1"></i>
                                {msg.updated_at}
                              </div>

                              {/* From → To */}
                              <div style={{ fontWeight: 600, marginBottom: "4px" }}>
                                <i className="fas fa-user-circle me-1"></i>
                                {msg.from_employee_name} → {msg.to_employee_name}
                              </div>

                              {/* Subject */}
                              {msg.subject && (
                                <div style={{ marginBottom: "6px" }}>
                                  <i className="fas fa-tag me-1"></i>
                                  <strong>Subject:</strong> {msg.subject}
                                </div>
                              )}

                              {/* Body */}
                              <div style={{ marginBottom: "8px", whiteSpace: "pre-line" }}>
                                <div  className="message-body" dangerouslySetInnerHTML={{ __html: msg.body }}  style={{ whiteSpace: "normal", wordBreak: "break-word" }}/>
                              </div>

                              {/* Attachments */}
                              {msg.attachments?.length > 0 && (
                                <div style={{ marginTop: "8px" }}>
                                  <div style={{ fontWeight: 600 }}>
                                    <i className="fas fa-paperclip me-1"></i>
                                    Attachments:
                                  </div>

                                  <div className="d-flex flex-column mt-1 gap-2">
                                    {msg.attachments.map((att) => (
                                      <div
                                        key={att.id}
                                        className="d-flex align-items-center"
                                        style={{ gap: "8px" }}
                                      >
                                        <i
                                          className={getFileIcon(att.file_name)}
                                          style={{ fontSize: "18px" }}
                                        ></i>

                                        <button
                                          type="button"
                                          className="btn btn-link p-0 text-start"
                                          onClick={() => {
                                            setSelectedMessage(msg);
                                            handleAttachmentClick(att, msg);
                                          }}
                                          style={{
                                            fontSize: "14px",
                                            maxWidth: "260px",
                                            whiteSpace: "nowrap",
                                            overflow: "hidden",
                                            textOverflow: "ellipsis",
                                          }}
                                        >
                                          {att.file_name}
                                        </button>
                                      </div>
                                    ))}
                                  </div>
                                </div>
                              )}
                            </div>

                            {/* Avatar for outgoing messages (right side) */}
                            {isMe && (
                              <div  className="avatar-circle" >
                                {initials}
                              </div>
                            )}
                          </div>
                        );
                      })}
                    </div>
                  );
                })}
              </div>
            </Modalpopup>
    </div>
  );
};

export default TicketMessages;
